import { Link } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";

const HomeEasyAccess = (props) => {
  const { sectionTitle, briefContent, sectionImg, borderTop, linkTo } = props;
  return (
    <div className="">
      <div
        className={
          borderTop ? "w-full h-[1px] bg-slate-200 rounded-2xl" : "none"
        }
      ></div>
      <li className="flex flex-col lg:flex-row py-8 gap-4 lg:gap-12">
        <div className="flex flex-col items-start order-2 lg:order-1 lg:w-1/3">
          <h2 className="font-[600] text-[24px] lg:text-[32px] text-[#ff610f]">
            {sectionTitle}
          </h2>
        </div>
        <div className="flex flex-col items-start gap-4 order-3 lg:order-2 lg:w-1/3">
          <p>{briefContent}</p>
          <Link to={linkTo}>
            <p className="font-[600] text-primary-500 flex items-center align-center gap-1 hover:underline transition-all hover:text-[#553192]">
              Voir Plus <BsArrowRightShort size={24} />
            </p>
          </Link>
        </div>
        <div className="rounded-xl overflow-hidden shadow-lg order-1 lg:order-3 lg:w-1/3 aspect-video">
          <img src={sectionImg} alt={sectionTitle} className="object-cover" />
        </div>
      </li>
    </div>
  );
};

export default HomeEasyAccess;
